import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

@Injectable()
export class NavigationService {

  navChanged = new Subject<boolean>();

  isLightTheme = false

  constructor() {
    this.isLightTheme = true;
  }

  setToLight(value: boolean) {
    this.isLightTheme = value;
    this.navChanged.next(this.isLightTheme)
  }
}

